import * as React from "react";
import Svg, { Path, G, Defs, LinearGradient, Stop } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg width={240} height={240} viewBox="0 0 240 240" fill="none" {...props}>
      <Path
        d="M198.659 31.173v164.51a7.39 7.39 0 01-7.392 7.39h-66.789a7.39 7.39 0 01-7.392-7.39V31.173a7.4 7.4 0 012.165-5.227 7.384 7.384 0 015.227-2.165h9.994v1.284a6.092 6.092 0 006.087 6.087h33.966a6.087 6.087 0 006.087-6.087V23.78h10.655a7.39 7.39 0 017.392 7.392z"
        fill="#007CD6"
        fillOpacity={0.05}
      />
      <Path
        opacity={0.5}
        d="M208.723 56.906h.662a.618.618 0 01.618.618v21.692a.618.618 0 01-.618.619h-.662M115.655 46.493h-.478a.405.405 0 01-.406-.405v-6.737a.406.406 0 01.406-.406h.478M115.58 65.902h-.408a.456.456 0 01-.457-.457V53.221a.457.457 0 01.457-.457h.484M115.579 83.752h-.402a.433.433 0 01-.435-.435V70.935a.433.433 0 01.435-.435h.402"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        opacity={0.5}
        d="M199.096 14H125.28c-5.316 0-9.626 4.31-9.626 9.626V193.52c0 5.316 4.31 9.625 9.626 9.625h73.816c5.316 0 9.626-4.309 9.626-9.625V23.626c0-5.316-4.31-9.626-9.626-9.626z"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        d="M164.981 20.457h-11.626a.685.685 0 00-.685.685v1.269c0 .378.307.685.685.685h11.626a.685.685 0 00.685-.685v-1.269a.685.685 0 00-.685-.685zM169.13 23.273a1.497 1.497 0 100-2.995 1.497 1.497 0 000 2.995z"
        fill="#F2F2F2"
      />
      <Path
        opacity={0.5}
        d="M165.522 19.648h-11.626a.685.685 0 00-.685.686v1.268c0 .378.307.686.685.686h11.626a.686.686 0 00.685-.686v-1.268a.685.685 0 00-.685-.686zM169.669 22.464a1.497 1.497 0 100-2.994 1.497 1.497 0 000 2.994z"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        opacity={0.5}
        d="M202.975 26.318v164.51a7.387 7.387 0 01-7.392 7.389h-66.789a7.39 7.39 0 01-7.392-7.389V26.318a7.383 7.383 0 012.165-5.227 7.405 7.405 0 015.227-2.165h9.995v1.284a6.084 6.084 0 006.086 6.086h33.966a6.085 6.085 0 006.087-6.087v-1.283h10.655a7.39 7.39 0 017.392 7.392v0z"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        d="M132.094 34.648h-8.36v1.08h8.36v-1.08zM132.094 36.535h-8.36v1.079h8.36v-1.079zM132.094 38.424h-8.36v1.078h8.36v-1.078z"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        d="M199.155 37.346h-.247l-.093-.078a2.01 2.01 0 00-.769-3.163 2.004 2.004 0 10-.748 3.861 2.072 2.072 0 001.315-.48l.093.077v.248l1.548 1.553.465-.466-1.564-1.552zm-1.857 0a1.4 1.4 0 01-1.375-1.668 1.395 1.395 0 011.904-1.02 1.397 1.397 0 01.864 1.29 1.383 1.383 0 01-.406.99 1.38 1.38 0 01-.987.408z"
        fill="#3F3D56"
        stroke="#3F3D56"
        strokeWidth={0.5}
        strokeMiterlimit={10}
      />
      <Path
        d="M184.917 62.158h-57.416a3.384 3.384 0 00-3.384 3.384v28.83a3.384 3.384 0 003.384 3.384h57.416a3.384 3.384 0 003.384-3.384v-28.83a3.384 3.384 0 00-3.384-3.384z"
        fill="#007CD6"
        fillOpacity={0.2}
      />
      <Path
        opacity={0.5}
        d="M188.445 55.418h-57.417a3.383 3.383 0 00-3.383 3.384v28.83a3.383 3.383 0 003.383 3.384h57.417a3.384 3.384 0 003.383-3.384v-28.83a3.384 3.384 0 00-3.383-3.384z"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        d="M160.461 74.842h-1.927c.283.443.467.956.554 1.54h1.852l-.488 1.825h-1.374c-.141.915-.507 1.643-1.097 2.184-.59.54-1.438.919-2.544 1.134l4.028 4.775v.129h-3.051l-4.461-5.227-.009-1.622h2.184c1.137 0 1.85-.458 2.139-1.373h-4.544l.479-1.826h4.01c-.301-.743-.962-1.121-1.982-1.133h-2.507l.543-2.24h8.674l-.479 1.834z"
        fill="#fff"
      />
      <Path
        d="M134.512 158.705h57.417a3.383 3.383 0 003.383-3.384v-28.83a3.383 3.383 0 00-3.383-3.384h-57.417a3.384 3.384 0 00-3.383 3.384v28.83a3.384 3.384 0 003.383 3.384z"
        fill="#007CD6"
        fillOpacity={0.2}
      />
      <Path
        opacity={0.5}
        d="M131.028 151.961h57.416a3.384 3.384 0 003.384-3.384v-28.83a3.384 3.384 0 00-3.384-3.384h-57.416a3.384 3.384 0 00-3.384 3.384v28.83a3.384 3.384 0 003.384 3.384z"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        d="M88.495 216.172s-.085.047-.23.121l.23-.121z"
        fill="url(#prefix__paint0_linear)"
      />
      <Path
        d="M56.333 187.911c-2.023 5.817.338 15.259 1.434 19.474 1.095 4.216 1.433 9.274 1.433 9.274 4.3.674 7.42-.169 7.42-.169l-1.771-8.683c1.264-5.143 0-18.885 0-18.885s2.865-5.311 3.118-13.404c.25-7.967 2.213-10.542 2.275-10.621l.002-.001c4.046 2.108 9.19 24.702 9.19 24.702-.422 5.479.084 13.91 1.77 18.462a22.858 22.858 0 011.264 9.02c.59.499 1.409.583 2.294.44 2.408-.389 5.293-2.463 5.293-2.463s-.927-24.617-1.602-25.544c-.674-.927 0-6.238 0-6.238l-1.095-8.599s.168-14.586-1.434-17.115c-1.382-2.184-1.7-6.022-1.763-7.03a20.881 20.881 0 01-.012-.248l-2.44-2.922s-23.605-1.77-25.376 0c-.435.435-.703 1.423-.862 2.667-.487 3.824.07 10.062.07 10.062s.709 4.637 1.72 9.358a20.497 20.497 0 010 8.599 25.72 25.72 0 01-.928 9.864z"
        fill="#006DBD"
      />
      <Path
        d="M57.807 224.879c1.054 1.391 7.25.8 8.305.367.644-.266.595-1.477.42-2.726-.11-.794-.271-1.603-.337-2.194-.168-1.517.506-4.595.506-4.595s-1.39 1.476-1.727 0c-.148-.645-.667-.976-1.204-1.144a3.146 3.146 0 00-2.188.138c-1.095.474-2.922 1.487-2.595 2.857.464 1.936-1.18 4.683-1.18 4.683a2.107 2.107 0 00-.307.53 2.025 2.025 0 00.307 2.084z"
        fill="#CBCEDA"
      />
      <Path
        opacity={0.1}
        d="M57.807 224.88c1.054 1.391 7.25.8 8.305.367.644-.266.595-1.477.42-2.726-.664.312-1.796.57-3.682.396-.44-.041-.883-.055-1.325-.041a30.891 30.891 0 01-4.025-.08 2.025 2.025 0 00.307 2.084zM79.43 189.596c-.421 5.479.084 13.91 1.77 18.463a22.857 22.857 0 011.265 9.02c.589.498 1.409.583 2.294.44-.509-3.556-2.676-18.876-4.065-30.98-1.58-13.783-8.978-23.268-8.978-23.268l-1.476 1.623c4.047 2.108 9.19 24.702 9.19 24.702z"
        fill="#000"
      />
      <Path
        d="M60.336 100.993l1.03 5.059 5.04 8.472 6.218-2.655s8.45-8.852 3.14-10.117a4.666 4.666 0 01-1.764-.785c-1.042-.787-1.371-1.93-1.376-3.049a9.341 9.341 0 01.863-3.627l-10.875-3.414c.45 1.429.711 2.91.78 4.406.084 2.961-1.016 4.42-1.92 5.116a3.271 3.271 0 01-1.136.594z"
        fill="#FBBEBE"
      />
      <Path
        opacity={0.1}
        d="M62.611 90.877c.45 1.429.712 2.91.78 4.406a8.606 8.606 0 009.231 2.635 9.341 9.341 0 01.865-3.627L62.61 90.877z"
        fill="#000"
      />
      <Path
        d="M61.367 89.486a8.6 8.6 0 108.6-8.6 8.567 8.567 0 00-8.6 8.6z"
        fill="#FBBEBE"
      />
      <Path
        opacity={0.1}
        d="M60.336 100.995l1.03 5.058 5.04 8.473 6.218-2.656s8.45-8.852 3.14-10.117a4.666 4.666 0 01-1.764-.785c.96 2.636-3 8.12-3 8.12-.46.678-1.517.253-1.517.253-2.55-.386-7.245-7.72-8.01-8.941a3.256 3.256 0 01-1.137.595zM55.47 150.028c1.497.34 9.78 2.175 12.92 1.716 3.456-.506 10.175-.842 10.175-.842s4.28.231 5.596-.371a21.918 21.918 0 01-.013-.248l-2.439-2.922s-23.606-1.77-25.376 0c-.435.435-.703 1.423-.862 2.667z"
        fill="#000"
      />
      <Path
        d="M71 109.339s4.448-6.163 2.772-8.561l7.513 3.081s4.522-.548 6.154 6.2a11.68 11.68 0 01.28 3.426c-.06 1.017.079 2.809 1.238 5.127 1.855 3.71 1.433 12.224-2.36 13.067-3.794.843-5.143.422-5.143.422s.506 15.427 2.698 17.198c2.192 1.77-5.59 1.349-5.59 1.349s-6.719.337-10.175.843c-3.457.506-13.152-1.771-13.152-1.771s1.433-6.491 1.94-10.622c.505-4.131 1.685-12.927 1.685-12.927l-8.599-11.648s-1.517-7.039 3.794-10.158c5.311-3.12 7.31-3.886 7.31-3.886s5.336 8.691 8.118 9.113c0 0 1.056.424 1.517-.253z"
        fill="#3F3D56"
      />
      <Path
        opacity={0.1}
        d="M80.866 111.783s.084 2.782-.421 3.878c-.506 1.096-2.361 7.166-2.361 7.166h4.215s-2.276-2.445-2.107-3.625c.168-1.18.674-7.419.674-7.419z"
        fill="#000"
      />
      <Path
        d="M68.388 132.776s9.308-2.276 10.176-4.215c.868-1.939 3.259-6.279 3.259-6.279l-.983-1.323-4.528 3.555s-5.395 4.3-7.924 4.721c-2.53.422 0 3.541 0 3.541z"
        fill="#FBBEBE"
      />
      <Path
        opacity={0.05}
        d="M68.388 132.776s9.308-2.276 10.176-4.215c.868-1.939 3.259-6.279 3.259-6.279l-.983-1.323-4.528 3.555s-5.395 4.3-7.924 4.721c-2.53.422 0 3.541 0 3.541z"
        fill="#000"
      />
      <Path
        d="M60.336 121.815v5.051h.812c4.01 0 7.956 1.021 11.463 2.967l1.521.844.41.228 2.613-5.887-2.445-2.191s-.044.005-.125.011c-.598.059-3.184.275-4.28-.096-1.041-.353-2.335-1.474-5.402-.69-1.51.385-2.8 2.079-4.265 1.55l-.302-1.787z"
        fill="#FBBEBE"
      />
      <Path
        opacity={0.1}
        d="M52.202 112.629l-1.686 1.897v4.594s1.433 14.501 5.985 16.102c4.553 1.602 12.68-.927 12.68-.927s2.098-5.564 1.116-5.901c-.981-.337-8.678-2.37-8.678-2.37s.11-8.506-1.577-11.035c0 0 1.096-7.924-2.698-8.093-3.793-.168-5.142 5.733-5.142 5.733z"
        fill="#000"
      />
      <Path
        d="M51.948 112.629l-1.686 1.897v4.594s1.433 14.501 5.985 16.102c4.553 1.602 12.68-.927 12.68-.927s2.098-5.564 1.116-5.901c-.981-.337-8.678-2.37-8.678-2.37s.11-8.506-1.577-11.035c0 0 1.096-7.924-2.698-8.093-3.793-.168-5.142 5.733-5.142 5.733z"
        fill="#3F3D56"
      />
      <Path
        opacity={0.1}
        d="M63.726 93.14a3.367 3.367 0 01.192-1.64c.238-.504.794-.9 1.336-.773.723.168 1.034 1.108 1.74 1.333.596.19 1.247-.233 1.532-.79.284-.557.292-1.21.293-1.834l.005-2.113c.002-.767.024-1.595.497-2.197.588-.75 1.97-1.077 2.891-1.047a2.445 2.445 0 011.65.665c.495.42 1.065.729 1.738.619a1.5 1.5 0 001.216-1.074 8.6 8.6 0 00-15.448 5.05 8.598 8.598 0 002.659 6.364 23.23 23.23 0 01-.301-2.562z"
        fill="#000"
      />
      <Path
        d="M75.6 85.11a1.502 1.502 0 001.211-1.048c.071-.272.053-.563.133-.832.197-.662.904-1.008 1.378-1.51.95-1.008.888-2.666.215-3.877-.542-.977-1.595-1.802-2.696-1.611-.682.118-1.272.604-1.963.648-.665.042-1.273-.33-1.88-.607a7.086 7.086 0 00-4.66-.414 2.685 2.685 0 00-1.282.647c-.245.308-.473.629-.684.961-.786 1.002-2.193 1.197-3.446 1.425-1.253.227-2.67.722-3.082 1.927-.273.798-.008 1.666.148 2.496.052.17.04.353-.033.515-.196.323-.685.188-1.055.266-.71.149-.893 1.065-.92 1.79-.03.831-.052 1.662-.067 2.494-.02.31.005.622.074.925.154.433.399.828.717 1.16l2.783 3.344c1.235 1.483 2.545 3.212 2.297 5.125.585.262 1.28-.243 1.471-.855.192-.612.037-1.27-.093-1.899a23.366 23.366 0 01-.44-3.292 3.355 3.355 0 01.193-1.641c.237-.504.794-.9 1.337-.774.722.169 1.032 1.108 1.74 1.333.595.19 1.247-.233 1.53-.79.285-.557.292-1.209.294-1.834l.005-2.113c.002-.766.024-1.594.497-2.197.588-.75 1.97-1.077 2.891-1.047a2.449 2.449 0 011.65.666c.495.42 1.064.728 1.738.618z"
        fill="#3F3D56"
      />
      <Path
        opacity={0.1}
        d="M73.656 111.572l-2.64 10.846s-2.082-.013 2.64-10.846zM64.637 109.762s3.456 5.66 2.107 11.513l-.644.047s1.15-2.708-1.463-11.56zM62.443 141.797s-4.244-1.404-4.552 1.855c0 0 .8-2.235 4.552-1.855zM74.71 123.08s.843 5.901-.675 8.262c0 0 3.087 1.264 7.419 1.012l.506-9.274h-7.25z"
        fill="#000"
      />
      <Path
        opacity={0.1}
        d="M74.135 130.679l.41.227 2.612-5.886-2.444-2.192h-.127c0 .004 0 .008.002.012.037.271.719 5.34-.453 7.839z"
        fill="#000"
      />
      <Path
        d="M74.71 122.828s.843 5.901-.675 8.262c0 0 3.087 1.265 7.419 1.012l2.95-9.274H74.71z"
        fill="#3F3D56"
      />
      <Path
        d="M81.463 223.448a1.911 1.911 0 001.637 1.67c2.29.342 7.804-.674 9.197-.011 1.77.843 8.767.253 9.105-.59a1.336 1.336 0 00-.122-1.014 2.691 2.691 0 00-1.13-1.215 2.775 2.775 0 00-.507-.225c-1.318-.44-3.808-1.374-4.48-2.351 0 0-3.102-2.715-3.987-4.183a2.022 2.022 0 00-1.621-1.009c-.739-.033-1.561.338-1.898 1.956 0 0-4.044 2.308-5.139.285 0 0-.168 4.996-.84 5.845a1.13 1.13 0 00-.215.842z"
        fill="#CBCEDA"
      />
      <Path
        opacity={0.1}
        d="M81.463 223.447a1.911 1.911 0 001.637 1.67c2.29.342 7.804-.674 9.197-.011 1.77.843 8.767.253 9.105-.589a1.343 1.343 0 00-.122-1.015 2.691 2.691 0 00-1.13-1.215c-1.14.756-3.674 1.497-9.244.627-5.314-.829-7.944.245-9.228-.308l-.004.005a1.113 1.113 0 00-.21.836z"
        fill="#000"
      />
      <G opacity={0.1} fill="#000">
        <Path
          opacity={0.1}
          d="M58.998 83.431l-.007-.04c-.12-.632-.301-1.286-.26-1.914.054.516.14 1.029.26 1.535a.913.913 0 01.007.42zM63.918 91.323a2.465 2.465 0 00-.207.964 2.903 2.903 0 01.207-1.343c.237-.504.794-.9 1.337-.774.722.17 1.032 1.108 1.74 1.334.595.19 1.247-.234 1.53-.79.285-.557.292-1.21.294-1.835l.005-2.113c.002-.765.024-1.594.497-2.197.588-.75 1.97-1.077 2.892-1.047a2.449 2.449 0 011.65.666c.494.42 1.064.728 1.737.619a1.502 1.502 0 001.21-1.048c.071-.272.053-.562.133-.832.197-.662.904-1.008 1.378-1.51a2.76 2.76 0 00.71-1.782 2.874 2.874 0 01-.71 2.161c-.474.503-1.181.848-1.378 1.51-.08.27-.062.56-.132.833a1.502 1.502 0 01-1.211 1.047c-.673.11-1.243-.199-1.738-.619a2.449 2.449 0 00-1.65-.665c-.922-.03-2.303.297-2.891 1.047-.473.602-.495 1.431-.497 2.197l-.005 2.113c-.002.625-.01 1.277-.293 1.834-.284.557-.936.98-1.532.79-.707-.225-1.017-1.164-1.74-1.333-.542-.127-1.099.27-1.336.773zM56.989 89.002c.154.433.399.829.717 1.16.927 1.116 1.855 2.23 2.783 3.345 1.172 1.408 2.412 3.037 2.322 4.836-.085-1.649-1.233-3.148-2.322-4.457l-2.783-3.344a3.27 3.27 0 01-.717-1.16 3.223 3.223 0 01-.074-.925c.003.184.027.367.074.546zM64.259 97.777c.045-.146.073-.298.083-.45.024.279-.004.56-.083.83-.192.612-.887 1.117-1.472.854.016-.122.026-.245.029-.369.579.234 1.254-.263 1.443-.865z"
        />
      </G>
      <Path
        opacity={0.1}
        d="M91.733 216.291s-.881 1.55-4.075.184l4.075-.184zM65.276 216.395s-2.755 3.242-6.225 1.063l6.225-1.063zM57.262 178.047s1.946 1.215 2.009 1.911c.063.695-1.005-.506-1.005-.506l-1.004-1.405zM56.492 187.369a4.06 4.06 0 002.398.936c1.454.063 1.333 1.96.382 1.391s-2.78-2.327-2.78-2.327zM56.121 188.586s.934 4.588 1.693 3.702l-1.693-3.702z"
        fill="#000"
      />
      <Path
        d="M33.697 183.96a5.609 5.609 0 004.976-.569 5.61 5.61 0 002.126-6.857 5.618 5.618 0 00-3.782-3.284 5.604 5.604 0 00-2.573-.054l.14 2.888-1.366-2.475a5.59 5.59 0 00-2.881 3.161 5.61 5.61 0 003.36 7.19z"
        fill="#00AB59"
      />
      <Path
        d="M40.458 217.466c-.483-2.457 1.608-4.635 3.673-6.051 2.065-1.415 4.478-2.806 5.183-5.209 1.012-3.453-2.004-6.615-4.352-9.342a33.797 33.797 0 01-4.456-6.623c-.488-.952-.937-1.948-1.066-3.011-.185-1.531.307-3.054.802-4.514a326.651 326.651 0 015.294-14.468"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        d="M33.927 183.216a5.609 5.609 0 004.977-.569 5.618 5.618 0 002.125-6.857 5.612 5.612 0 00-6.354-3.339l.14 2.889-1.366-2.475a5.59 5.59 0 00-2.882 3.161 5.611 5.611 0 003.36 7.19v0z"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        d="M39.772 167.25a5.603 5.603 0 014.04-3.559l.462 2.746.857-2.884a5.612 5.612 0 11-5.359 3.697z"
        fill="#00AB59"
      />
      <Path
        d="M40.083 166.26a5.607 5.607 0 014.04-3.559l.462 2.746.856-2.885a5.613 5.613 0 11-.233 11.222 5.614 5.614 0 01-5.125-7.524h0z"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        d="M43.979 196.921a5.612 5.612 0 004.967-9.985l-.658 2.217-.467-2.779a5.602 5.602 0 00-4.307.185 5.613 5.613 0 00.465 10.362z"
        fill="#00AB59"
      />
      <Path
        d="M44.246 195.915a5.612 5.612 0 004.968-9.984l-.659 2.216-.466-2.779a5.602 5.602 0 00-4.307.185 5.612 5.612 0 00.465 10.362h0z"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        d="M38.135 206.241a5.612 5.612 0 008.91 3.502 5.612 5.612 0 00-.95-9.527 5.612 5.612 0 00-6.878 1.63l2.5 3.764-3.417-1.998a5.56 5.56 0 00-.165 2.629z"
        fill="#00AB59"
      />
      <Path
        d="M38.367 205.495a5.611 5.611 0 008.911 3.502 5.611 5.611 0 00-4.679-9.932 5.61 5.61 0 00-3.15 2.035l2.5 3.763-3.416-1.997a5.558 5.558 0 00-.166 2.629v0z"
        stroke="#3F3D56"
        strokeMiterlimit={10}
      />
      <Path
        d="M32.668 220.793s4.953-1.941 6.445-3.004c1.493-1.063 7.62-2.332 7.99-.627.37 1.704 7.442 8.478 1.85 8.523-5.59.045-12.992.917-14.482.01-1.49-.908-1.803-4.902-1.803-4.902z"
        fill="#656380"
      />
      <Path
        opacity={0.2}
        d="M49.054 225.092c-5.592.045-12.993.918-14.483.01-1.134-.691-1.586-3.171-1.738-4.315l-.165.007s.314 3.994 1.803 4.902c1.49.907 8.891.035 14.483-.01 1.614-.013 2.171-.588 2.14-1.438-.223.514-.839.834-2.04.844z"
        fill="#000"
      />
      <Path d="M43.705 225.465h73.353" stroke="#3F3D56" strokeMiterlimit={10} />
      <Path
        d="M167.475 135.789h-1.927c.283.443.467.956.553 1.54h1.853l-.489 1.825h-1.373c-.141.915-.507 1.644-1.097 2.184-.59.541-1.438.919-2.544 1.134l4.028 4.775v.129h-3.051l-4.461-5.226-.009-1.623h2.184c1.137 0 1.85-.458 2.139-1.373h-4.545l.48-1.825h4.009c-.301-.744-.961-1.122-1.981-1.134h-2.508l.544-2.24h8.674l-.479 1.834z"
        fill="#fff"
      />
      <Defs>
        <LinearGradient
          id="prefix__paint0_linear"
          x1={88.38}
          y1={216.293}
          x2={88.38}
          y2={216.172}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="gray" stopOpacity={0.25} />
          <Stop offset={0.535} stopColor="gray" stopOpacity={0.12} />
          <Stop offset={1} stopColor="gray" stopOpacity={0.1} />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}

export default SvgComponent;
